import request from "@/router/axios";

export const getList = (current, size, params) => {
  return request({
    url: "/api/jida-report/report/rest/list",
    method: "get",
    params: {
      ...params,
      current,
      size,
    },
  });
};
export const remove = (ids) => {
  return request({
    url: "/api/jida-report/report/rest/remove",
    method: "post",
    params: {
      ids,
    },
  });
};

export const getMachineDetail = (params) => {
  return request({
    method: "post",
    params: params,
    url: "/api/park-statistics/statistics/queryReceiptByContractCode",
  });
};
